export enum PreCheckinSharedStateActionTypes {
  SetHasRequestError = '[SetHasRequestError] action',
  SetHasTriedToSave = '[SetHasTriedToSave] action'
}

export class SetHasRequestError {
  public static readonly type =
    PreCheckinSharedStateActionTypes.SetHasRequestError;

  constructor(public hasRequestError: boolean) {}
}

export class SetHasTriedToSave {
  public static readonly type =
    PreCheckinSharedStateActionTypes.SetHasTriedToSave;

  constructor(public hasTriedToSave: boolean) {}
}
